import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useTranslation } from "react-i18next";
import { HOLIDAY_IMAGES } from "../../data/holidays";
import { Chapter, Reveal, Marquee } from "./shared";

export default function HolidayIntro() {
  const { t } = useTranslation();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <>
      <Marquee />
      <section ref={ref} className="bg-bone py-24 lg:py-40 overflow-hidden" data-testid="holidays-intro">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <Chapter number={t("holidays.intro.chapter")} label={t("holidays.intro.eyebrow")} />
            <Reveal delay={0.1}>
              <h2 className="font-display text-5xl sm:text-6xl lg:text-8xl text-forest leading-[0.98] mt-8 uppercase tracking-tight">
                {t("holidays.intro.title").split(" ").map((w, i) => (
                  <span key={i} className={`block ${i === 1 ? "italic normal-case pl-[8%]" : ""}`}>{w}</span>
                ))}
              </h2>
            </Reveal>
            <Reveal delay={0.2} className="mt-10 space-y-6 max-w-xl">
              <p className="text-forest text-lg md:text-xl leading-relaxed font-light">{t("holidays.intro.p1")}</p>
              <p className="text-muted-foreground text-base md:text-lg leading-relaxed">{t("holidays.intro.p2")}</p>
              <p className="text-muted-foreground text-base md:text-lg leading-relaxed">{t("holidays.intro.p3")}</p>
              <p className="text-muted-foreground text-base md:text-lg leading-relaxed border-l-2 border-terracotta pl-6">{t("holidays.intro.p4")}</p>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="lg:col-span-6 lg:pt-24">
            <div className="relative">
              <div className="hol-frame relative aspect-[4/5] sm:aspect-[5/4] lg:aspect-[4/5] overflow-hidden bg-stoneWarm">
                <motion.img
                  src={HOLIDAY_IMAGES.intro}
                  alt={t("holidays.intro.alt")}
                  loading="lazy"
                  decoding="async"
                  style={{ y: imgY }}
                  className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-4 sm:-left-8 bg-forest text-bone px-6 py-5">
                <div className="text-[10px] uppercase tracking-wider-3 opacity-70">Apuseni Active</div>
                <div className="font-display italic text-2xl mt-1">Stay. Ride. Explore.</div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
